import React from "react";
import ChartCard from "./ChartCard";
import Pie from "../charts/Pie";

export default class EventTypeDistributionCard extends React.Component{
    render(){
        return (
            <ChartCard title="Event type distribution">
                <Pie resource="event-distribution" />
            </ChartCard>
        )
    }
}